import { Box, Grow, Stack, Typography } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDrawerFooter from "../../../../components/CustomDrawar/customDrawarFooter";
import CustomDrawerHeader from "../../../../components/CustomDrawar/customDrawarHeader";
import SnackbarAlert from "../../../../components/SnackBar";
import { setTabActive } from "../../../../lib/slices/tabActiveSlice";
import { fetchTimeSlots } from "../../../../services/appointments";

const Calendar = ({
  setIsLoading,
  selectedTimesss,
  selectedDatesss,
  selectedTeam,
  handleSelectedDateTime,
}) => {
  const tabActive = useSelector((state) => state.tabActive.tabs);
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(selectedDatesss || "");
  const [availableTime, setAvailableTime] = useState([]);
  const [selectedTime, setSelectedTime] = useState(selectedTimesss || null);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const disablePastDates = (date) => {
    const today = dayjs().startOf("day");
    return dayjs(date).isBefore(today);
  };
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };
  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const handleFetchTime = async (day) => {
    setAvailableTime([]);
    setSelectedDate(day);

    if (!day || !day?.$d) {
      console.warn("Invalid day object passed to handleFetchTime");
      return;
    }

    try {
      const result = selectedTeam?.map((item) => ({
        serviceDuration: item.duration,
        teamMemberID: item.teamMemberID,
      }));

      const params = {
        services: result,
        appointmentDate: day?.$d,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      setIsLoading(true);
      const response = await fetchTimeSlots(params);
      setIsLoading(false);
      if (response?.status === 200 || response?.status === 201) {
        let availableSlots = response?.data?.availableSlots || [];
        if (availableSlots?.length > 0) {
          const currentDate = new Date();
          const currentDateString = currentDate.toISOString().split("T")[0];
          const currentHours = currentDate.getHours();
          const currentMinutes = currentDate.getMinutes();
          if (day?.$d === currentDateString) {
            availableSlots = availableSlots.filter((time) => {
              const [hours, minutes] = time.split(":").map(Number);
              return (
                hours > currentHours ||
                (hours === currentHours && minutes > currentMinutes)
              );
            });

            if (availableSlots?.length === 0) {
              return handleSnackbarVal(
                true,
                "error",
                "Can't reschedule your appointment for today. Please select another date."
              );
            }
          }

          setAvailableTime(availableSlots);
        } else {
          handleSnackbarVal(
            true,
            "error",
            "The selected team member is unavailable on this day. Please choose a different date."
          );
        }
      } else {
        handleSnackbarVal(
          true,
          "error",
          response?.data?.message || "Failed to fetch time slots"
        );
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error, "Error while fetching time slots");
    }
  };

  const handleNext = () => {
    if (selectedTime && selectedDate) {
      const formattedDate = selectedDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      handleSelectedDateTime(formattedDate, selectedTime);
      dispatch(setTabActive(4));
    } else {
      handleSnackbarVal(true, "error", "Please select date and time");
    }
  };

  const handleBack = () => {
    if (selectedTeam[0]?.selectedFrom == "professional") {
      dispatch(setTabActive(1));
    } else {
      dispatch(setTabActive(2));
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
      }}
    >
      <CustomDrawerHeader title={"Select Date & Time"} onBack={handleBack} />
      <Stack
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          pb: "100px", // Add padding bottom to prevent content from going under the footer
        }}
      >
        <Box height="250px" sx={{ flexShrink: 0 }}>
          <DateCalendar
            onChange={(newDate) => handleFetchTime(newDate)}
            shouldDisableDate={disablePastDates}
            sx={{
              width: "100%",
              "& .MuiPickersCalendarHeader-root": {
                width: "100%",
                maxWidth: "100%",
              },
              "& .MuiDayCalendar-header, & .MuiDayCalendar-weekContainer": {
                margin: "0 0",
              },
              "& .MuiDayCalendar-weekDayLabel": {
                fontSize: "14px",
                margin: "0 9px",
              },
              "& .MuiDayCalendar-header": {
                width: "450px",
              },
              "& .MuiPickersDay-root": {
                margin: "0 12px",
                padding: "0",
                width: "30px",
                height: "30px",
                fontSize: "14px",
              },
            }}
          />
        </Box>
        <Box
          width="100%"
          alignItems="center"
          justifyContent="center"
          padding="10px"
          sx={{ flexShrink: 0 }}
        >
          <Typography
            fontSize={15}
            fontWeight={600}
            textAlign="center"
            sx={{ textDecoration: "underline", textDecorationColor: "black" }}
          >
            Select Time
          </Typography>
          <Typography
            fontSize={12}
            fontWeight={500}
            color="gray"
            textAlign="center"
          >
            {availableTime?.length > 0 ? "" : "Please select Date first"}
          </Typography>
        </Box>

        {availableTime?.length > 0 && (
          <Grow in={Boolean(availableTime?.length > 0)} timeout={500}>
            <Box
              width="100%"
              display="flex"
              gap="10px"
              flexWrap="wrap"
              padding="4px"
              justifyContent="center"
            >
              {availableTime.map((item, index) => (
                <Box
                  key={index}
                  width="90px"
                  height="50px"
                  borderRadius="10px"
                  border={1}
                  display="flex"
                  borderColor="divider"
                  textAlign="center"
                  alignItems="center"
                  justifyContent="center"
                  onClick={() => setSelectedTime(item)}
                  sx={{
                    cursor: "pointer",
                    backgroundColor:
                      selectedTime === item ? "primary.main" : "transparent",
                    color: selectedTime === item ? "white" : "inherit",
                    "&:hover": {
                      backgroundColor:
                        selectedTime === item ? "primary.dark" : "action.hover",
                    },
                  }}
                >
                  <Typography fontSize={12} fontWeight={500}>
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grow>
        )}
      </Stack>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          bgcolor: "background.paper",
          borderTop: 1,
          borderColor: "divider",
          maxWidth: "430px",
          width: "430px",
        }}
      >
        <CustomDrawerFooter
          activeStep={tabActive}
          btnTitle={"Next"}
          onNext={handleNext}
        />
      </Box>
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </Box>
  );
};

export default Calendar;
